import type { Directive } from 'vue';

// v-reveal: blendet ein Element beim ersten Sichtbarwerden sanft von unten ein.
// Ohne IntersectionObserver oder bei "Bewegung reduzieren" bleibt es einfach sichtbar.
export const vReveal: Directive<HTMLElement> = {
  mounted(el) {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    el.classList.add('reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add('reveal-in');
            observer.disconnect();
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' },
    );
    observer.observe(el);
  },
};
